// What the shell draws where a screen isn't: a screen still being built (its file isn't in
// src/admin/screens/ yet), a page the role doesn't open, an address admin doesn't have, and a screen
// that failed. No board draws these; the words are in the stage 5 batch for Adam.
import { PageHeader, Card, ButtonLink } from '../ui/index.js'

export function Holding({ title }) {
  return (
    <>
      <PageHeader eyebrow="Admin" title={title} />
      <Card className="ad-holding" title="Still being built">
        <p className="ad-lede">This page is still being built. Everything else in admin works as normal.</p>
      </Card>
    </>
  )
}

export function NotForRole({ title }) {
  return (
    <>
      <PageHeader eyebrow="Admin" title={title} />
      <Card className="ad-holding" title="Not part of your role">
        <p className="ad-lede">Your role doesn't open this page. If you need it, ask the owner to change your role.</p>
        <p><ButtonLink to="/admin" size="sm">Back to Today</ButtonLink></p>
      </Card>
    </>
  )
}

export function NoSuchPage() {
  return (
    <>
      <PageHeader eyebrow="Admin" title="There's nothing here" />
      <Card className="ad-holding" title="Not an admin page">
        <p className="ad-lede">There's no admin page at this address. Use the menu to find what you need.</p>
        <p><ButtonLink to="/admin" size="sm">Back to Today</ButtonLink></p>
      </Card>
    </>
  )
}

export function ScreenFailed({ title }) {
  return (
    <>
      <PageHeader eyebrow="Admin" title={title} />
      <div className="ad-problem" role="alert">
        <p className="ad-problem-text">This page didn't load. Reload the page to try again. The rest of admin still works.</p>
      </div>
    </>
  )
}
